import { Color } from "../theme/colors";

const colors = () => Color;

export default colors;
